<template>
    <div>
        <v-card dark class="pa-4 grey darken-3 ma-4">
            <v-toolbar dark flat dense class="grey darken-3">
                <v-toolbar-title>Картка Історії пакетного продажу You TV</v-toolbar-title>
            </v-toolbar>
    
            <v-card-text>
                <v-flex xs4 lg1>
                    <v-text-field v-model="soldData.sell_date" label="Дата" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.seller" label="Ким продано" readonly></v-text-field>
                    <v-text-field v-model="soldData.typhoon_doc" label="ID документа Тайфун" readonly></v-text-field>
                </v-flex>
                <v-subheader>Покупець</v-subheader>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.fio" label="ПІБ" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.phone" label="Телефон" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.contractor" label="Контрагент" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="soldData.shopName" label="ТТ" readonly></v-text-field>
                </v-flex>
                <v-subheader>Продано пакети You TV</v-subheader>
                <v-flex xs12 lg6>
                    <v-simple-table dark>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Пакет
                                    </th>
                                    <th class="text-left">
                                        Кількість
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in soldList" :key="item.name">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.sold_out }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="grey" @click="goBack()">
                    <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                </v-btn>
                <v-btn text v-if="soldData.typhoon_doc == 0" color="error" @click="sendToTyphoon()">
                    Сформувати документ Тайфун
                </v-btn>
                <v-btn small text v-if="soldData.id" @click="exportData(soldData.reserved_token)" class="megogo--text">
                    Експорт продажів <v-icon class="pl-3">mdi-export</v-icon>
                </v-btn>
    
            </v-card-actions>
        </v-card>
    </div>
    </template>
    
    <script>
    import {
        ValidationObserver,
        ValidationProvider
    } from "vee-validate"
    
    import {
        mapActions
    } from 'vuex'
    
    import {
        mask
    } from "vue-the-mask"
    
    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        directives: {
            mask
        },
        data() {
            return {
                f: {},
                usersTable: false,
                search: '',
                footerProps: {
                    'items-per-page-options': [10, 20],
                    'items-per-page-text': 'на стор.'
                },
                headers: [{
                        text: 'ID',
                        align: 'left',
                        sortable: true,
                        value: 'member_id',
                        selected: false,
                        width: '5%',
                    },
                    {
                        text: 'Телефон',
                        align: 'left',
                        sortable: true,
                        value: 'phone',
                        selected: true,
                        width: '10%',
                    },
                    {
                        text: 'ПІБ',
                        align: 'left',
                        sortable: true,
                        value: 'name',
                        selected: true,
                        width: '20%',
                    },
                    {
                        text: 'E-mail',
                        align: 'left',
                        sortable: true,
                        value: 'email',
                        selected: true,
                        width: '15%',
                    },
                    {
                        text: 'Тип',
                        align: 'left',
                        sortable: true,
                        value: 'owner',
                        selected: true,
                        width: '10%',
                    },
                    {
                        text: 'Контрагенти',
                        align: 'left',
                        sortable: true,
                        value: 'contractors',
                        selected: true,
                        width: '20%',
                    },
                    {
                        text: 'ТТ',
                        align: 'left',
                        sortable: true,
                        value: 'shops',
                        selected: true,
                        width: '20%',
                    },
                ]
            }
        },
        methods: {
            ...mapActions(['setSnackbar', 'touch', 'getUsersList', 'getYoutvSoldList', 'getYoutvSoldData', 'getYoutvStatExport', 'createXlsx', 'sendYoutvToTyphoon']),
            goBack() {
                window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
            },
            getUsers() {
                this.usersTable = true
                this.getDataFromApi()
            },
            getDataFromApi() {
                this.getUsersList()
            },
            exportData(reserved_token) {
                this.getYoutvStatExport({
                        status: [2],
                        dateTo: this.exportTo,
                        dateFrom: this.exportFrom,
                        reserved_token
                    })
                    .then(data => {
                        this.createXlsx(data)
                            .then(
                                () => {
                                    this.openExport = false
                                    window.open(process.env.NODE_ENV === 'production' ? '/api/xlsx/file/Report.xlsx' : 'http://dev.extraservices.com.ua:3003/api/xlsx/file/Report.xlsx')
                                }
                            )
                    })
                    .catch(error => this.setSnackbar(['error', error]))
            },
            sendToTyphoon() {
                this.sendYoutvToTyphoon({
                    contractor_id: this.soldData.contractor_id,
                    id: this.soldData.id,
                    reserved_token: this.soldData.reserved_token
                })
                .then(data => {
                    if(data.error){
                        this.setSnackbar(['error', data.error])
                    }
                    if(data.doc_id){
                        this.setSnackbar(['info', 'Документ Тайфун створено'])
                        this.getYoutvSoldData(this.$route.params.id)
                    }
                })
                .catch(error => console.log(error))
            }
        },
        created() {
            this.getYoutvSoldList(this.$route.params.id)
            this.getYoutvSoldData(this.$route.params.id)
        },
        computed: {
            list() {
                return this.$store.state.adminpanel.usersList
            },
            soldList() {
                return this.$store.state.adminpanel.youtvSoldList
            },
            soldData() {
                return this.$store.state.adminpanel.youtvSoldData
            }
    
        },
        watch: {}
    }
    </script>
    
    <style>
    .inp-cnt {
        color: black;
        margin-left: 3px;
        margin-right: 3px;
        border: 1px solid rgb(7, 0, 0);
        width: 40px;
        text-align: center;
        padding: 1px;
        border-radius: 4px;
        box-sizing: border-box;
        background: #ffffff;
    }
    </style>
    